import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-function",
  "use": "icon-function-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-function\"><defs><style type=\"text/css\"></style></defs><path d=\"M63.3 151.3h896v174.2h-896V151.3zM63.3 425.1h896v174.2h-896V425.1zM63.3 698.9h896v174.2h-896V698.9z\" p-id=\"3254\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol